import { OneClickEstimateProvider } from "./pcb/OneClickEstimateContext"
import { SaveEstimateProvider } from "./save/SaveEstimateContext"

const EstimateProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <OneClickEstimateProvider>
      <SaveEstimateProvider>{children}</SaveEstimateProvider>
    </OneClickEstimateProvider>
  )
}

export default EstimateProvider
